export default "__VITE_ASSET__ArZzctZr__"